var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.386 19.9889H4.61395C2.06512 19.9889 0 17.9145 0 15.3657V8.47264C0 7.20752 0.781395 5.61682 1.78605 4.83543L6.8 0.928451C8.30698 -0.243642 10.7163 -0.299456 12.2791 0.798218L18.0279 4.82612C19.1349 5.59822 20 7.25403 20 8.60287V15.375C20 17.9145 17.9349 19.9889 15.386 19.9889ZM7.65581 2.02612L2.64186 5.9331C1.9814 6.45403 1.39535 7.63543 1.39535 8.47264V15.3657C1.39535 17.1424 2.83721 18.5936 4.61395 18.5936H15.386C17.1628 18.5936 18.6047 17.1517 18.6047 15.375V8.60287C18.6047 7.70985 17.9628 6.47264 17.2279 5.97031L11.4791 1.9424C10.4186 1.19822 8.66977 1.23543 7.65581 2.02612Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99846 16.2681C9.61706 16.2681 9.30078 15.9518 9.30078 15.5704V12.7797C9.30078 12.3983 9.61706 12.082 9.99846 12.082C10.3799 12.082 10.6961 12.3983 10.6961 12.7797V15.5704C10.6961 15.9518 10.3799 16.2681 9.99846 16.2681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.a5b23862bf850982bd4f891e585fb303.svg";
export { ForwardRef as ReactComponent };